import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component'
import { CodeEditorComponent } from './components/code-editor/code-editor.component'
import { AceModule } from 'ngx-ace-wrapper'
import { ButtonModule } from 'primeng/button'
import { PictureDialogComponent } from './components/picture-dialog/picture-dialog.component'
import { BuildInfoDialogComponent } from './components/build-info-dialog/build-info-dialog.component'
import { TableModule } from 'primeng/table'
import { EditorModule } from 'primeng/editor'
import { FormsModule } from '@angular/forms'
import { CodeWrapperDlgSrvcComponent } from './components/code-editor/code-wrapper-dlg-srvc/code-wrapper-dlg-srvc.component'
import { ConfirmationService } from 'primeng/api'

@NgModule({
  declarations: [
    RichTextEditorComponent,
    CodeEditorComponent,
    PictureDialogComponent,
    BuildInfoDialogComponent,
    CodeWrapperDlgSrvcComponent
  ],
  imports: [CommonModule, AceModule, ButtonModule, TableModule, EditorModule, FormsModule],
  exports: [RichTextEditorComponent, CodeEditorComponent, PictureDialogComponent, BuildInfoDialogComponent],
  providers: [ConfirmationService]
})
export class MiscModule {}
